var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizztime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.3548,
    fill: "#C5DCFF",
    stroke: "white",
    strokeWidth: 1.29032
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2799,
    cy: 22.524,
    r: 3.84627,
    stroke: "#656565",
    strokeWidth: 1.39062
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.0508,
    y: 19.5938,
    width: 0.450735,
    height: 0.901469,
    rx: 0.225367,
    fill: "#656565"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0508,
    y: 24.5508,
    width: 0.450735,
    height: 0.901469,
    rx: 0.225367,
    fill: "#656565"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3086,
    y: 22.748,
    width: 0.450735,
    height: 0.901469,
    rx: 0.225367,
    transform: "rotate(-90 24.3086 22.748)",
    fill: "#656565"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3516,
    y: 22.748,
    width: 0.450735,
    height: 0.901469,
    rx: 0.225367,
    transform: "rotate(-90 19.3516 22.748)",
    fill: "#656565"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1445,
    y: 20.8398,
    width: 0.450735,
    height: 0.450735,
    rx: 0.225367,
    transform: "rotate(-90 20.1445 20.8398)",
    fill: "#656565"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9609,
    y: 20.8398,
    width: 0.450735,
    height: 0.450735,
    rx: 0.225367,
    transform: "rotate(-90 23.9609 20.8398)",
    fill: "#656565"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9609,
    y: 24.6523,
    width: 0.450735,
    height: 0.450735,
    rx: 0.225367,
    transform: "rotate(-90 23.9609 24.6523)",
    fill: "#656565"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1445,
    y: 24.6523,
    width: 0.450735,
    height: 0.450735,
    rx: 0.225367,
    transform: "rotate(-90 20.1445 24.6523)",
    fill: "#656565"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0508 22.4503V21.1206C22.0868 21.0125 22.186 20.9704 22.2311 20.9629C22.4354 20.9629 22.509 21.0831 22.509 21.1432V22.3902V22.4503L22.8771 22.8109L23.8011 23.7499C23.9153 23.9302 23.7836 24.0504 23.7035 24.088C23.6133 24.118 23.5207 24.0755 23.4856 24.0504L22.1109 22.6757C22.0688 22.6396 22.0533 22.5805 22.0508 22.5555V22.4503Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3995 11.2007C21.6156 11.212 21.94 11.2763 22.2151 11.4366C22.4943 11.5995 22.7355 11.871 22.7355 12.2894V12.8608C22.7355 12.8639 22.7351 12.8671 22.7349 12.8702C22.7225 13.0443 22.6459 13.2963 22.4574 13.5071C22.2647 13.7225 21.9625 13.8859 21.5191 13.8859H14.9308V25.9944C14.9308 26.0703 14.8695 26.1322 14.7936 26.1323H12.3828C12.3069 26.1323 12.245 26.0703 12.245 25.9944V14.013H9.59053C9.58197 14.013 9.57313 14.0121 9.56473 14.0105C9.32144 13.9641 8.96422 13.8244 8.66545 13.5524C8.36276 13.2768 8.12109 12.8655 8.12109 12.2894V11.3378C8.12109 11.262 8.18242 11.2 8.25828 11.2L21.3995 11.2007Z",
    fill: "#656565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2568 23.3828C17.4867 24.4459 18.0586 25.3809 18.8514 26.0687H16.253C16.1772 26.0687 16.1158 26.0067 16.1158 25.9309V23.52C16.1158 23.4441 16.1772 23.3828 16.253 23.3828H17.2568Z",
    fill: "#656565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5348 7.07617C22.8283 7.07623 23.2464 7.16558 23.7028 7.33041C24.1618 7.49621 24.6694 7.74217 25.1433 8.06293C26.0862 8.70121 26.9229 9.65725 26.9229 10.8936V13.6852C26.9229 13.6905 26.9229 13.6962 26.9223 13.7015C26.8784 14.0747 26.738 14.6668 26.4591 15.2452C26.211 15.7599 25.8464 16.275 25.3314 16.6102C25.9238 17.0347 26.9229 18.08 26.9229 19.7762V21.2834C26.4418 19.056 24.4612 17.3868 22.0898 17.3868C21.2653 17.3868 20.4884 17.5899 19.8048 17.9468H16.253C16.1772 17.9468 16.1159 17.8854 16.1158 17.8097V15.3981C16.1159 15.3224 16.1772 15.261 16.253 15.261H22.217C22.5375 15.261 23.0621 15.0467 23.5115 14.6562C23.9569 14.269 24.3005 13.7329 24.3006 13.1144V11.9206C24.1959 11.3186 23.6078 10.0678 22.076 9.82499H9.78121C9.7718 9.82499 9.7621 9.82439 9.75289 9.82247C9.48413 9.76646 9.08391 9.62313 8.74726 9.37126C8.40902 9.11814 8.12109 8.74318 8.12109 8.22844V7.21336C8.12109 7.1375 8.18242 7.07618 8.25828 7.07617H22.5348Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizztime);
export default __webpack_public_path__ + "static/media/Bizztime.41abf4335e90a636e57aa1d3643d64a2.svg";
export { ForwardRef as ReactComponent };